import React from 'react';

import { Formik } from 'formik';
import Yup from 'yup';
import {Input, SubmitButton, TextArea, RGForm} from 'views/FormElements';
import {Separator, Title} from 'views/AppElements';
import HttpService from 'service/HttpService';

import AppUtil from 'AppUtil';


class UserSettingsForm extends React.Component {

	constructor(props) {
		super(props);
		this.handleSubmission = this.handleSubmission.bind(this);
	}

	getInitValues(user) {
		const socialMediaAccounts = user.socialMediaAccounts? user.socialMediaAccounts: {};
		const initValues = {username: user.username, 
							emailAddress: user.emailAddress? user.emailAddress: '', 
							phoneNumber: user.phoneNumber? user.phoneNumber: '',
							storeName: user.storeName? user.storeName: '',
							about: user.about? user.about: '',
							address: user.address? user.address: '',

							facebookUrl: socialMediaAccounts['FB']? socialMediaAccounts['FB']: '',
							instaUrl: socialMediaAccounts['INSTA']? socialMediaAccounts['INSTA']: '',
							ytUrl: socialMediaAccounts['YOUTUBE']? socialMediaAccounts['YOUTUBE']: '',
							tiktokUrl: socialMediaAccounts['TIKTOK']? socialMediaAccounts['TIKTOK']: ''
					};
		return initValues;
	}


	validationScheme() {
		return Yup.object().shape({
		    username: Yup.string().required('Please enter a Username.'),
		    phoneNumber: AppUtil.phoneNumberValidation(),
			emailAddress: Yup.string().email('Email address is invalid.').required('Please provide your Email Address.'),
			about: Yup.string().max(100, 'Max. 100 characters'),
			tiktokUrl: Yup.string(),
			instaUrl: Yup.string(),
			facebookUrl: Yup.string(),
			ytUrl: Yup.string().when(['tiktokUrl', 'instaUrl', 'facebookUrl'], (tiktokUrl, instaUrl, facebookUrl, schema) => {
				if(!tiktokUrl && !instaUrl && !facebookUrl)
					return Yup.string().required('Provide at least your one social media account');

				return Yup.string();
			})
		});
	}

	handleSubmission(values, {setSubmitting}) {
		if(this.props.readOnly === true) {
			alert("You are not authorized to perform this action!");
            return;	
		}

		const udpateUser = {username: values.username, emailAddress: values.emailAddress, 
							phoneNumber: values.phoneNumber, storeName: values.storeName, 
							about: values.about, address: values.address,
					};

		const socialMediAccounts = {};

		if(values.facebookUrl) socialMediAccounts['FB'] = values.facebookUrl;
		if(values.instaUrl) socialMediAccounts['INSTA'] = values.instaUrl;
		if(values.ytUrl) socialMediAccounts['YOUTUBE'] = values.ytUrl;
		if(values.tiktokUrl) socialMediAccounts['TIKTOK'] = values.tiktokUrl;

		udpateUser['socialMediaAccounts'] = socialMediAccounts;

		HttpService.updateUserInfo(udpateUser, function(success) {
			setSubmitting(false);
		});
	}

	render() {
		const user = this.props.user;
		if(!user)
			return null;

		const isStore = user.storeName !== null && user.storeName !== undefined;
		const initValues = this.getInitValues(user);
		return <Formik enableReinitialize initialValues={initValues} onSubmit={this.handleSubmission}
						validationSchema={this.validationScheme} render={({isSubmitting, values}) => {
							let submitBtn = "Update";
		
							if(isSubmitting === true)
								submitBtn = <span>Updating <i className="fa fa-circle-o-notch fa-spin" aria-hidden="true"></i></span>;

							return <RGForm>
								<Title title="About You" style={{textAlign: 'left'}} separatorPosition="top" />
								<Input name="username" type="text" label="Username: " style={{marginBottom: "0px"}} />
								<Input name="phoneNumber" type="text" label="Phone Number: " 
										style={{marginBottom: "0px"}} placeholder="E.g. 9862441133" disabled={user.phoneNumber? true: false}/>

								<Input name="emailAddress" type="text" label="Email: " style={{marginBottom: "0px"}} disabled={user.emailAddress? true: false} />
								<Input name="address" type="text" label="Address: " style={{marginBottom: "0px"}} />

								{
									isStore &&
									<div>
										<Separator style={{margin: '30px auto'}}/>
										<Input name="storeName" type="text" label="Store Name: " style={{marginBottom: "0px"}} disabled={true} />
									</div>
								}
								
								
								<TextArea placeholder={"Max 100 characaters"} label={isStore? "Store Info:": "About you:"}  name="about" rows="3"/>

								<h3>Social Media Accounts: </h3>
								
								<Input name="facebookUrl" label="Facebook:" type="text" placeholder="Enter your Facebook URL" style={{marginTop: '5px' }} />
								<Input name="instaUrl" label="Instagram:"  type="text" placeholder="Enter your Instagram URL" style={{marginTop: '5px' }} />
								<Input name="tiktokUrl" label="Tiktok:" type="text" placeholder="Enter your Tiktok URL" style={{marginTop: '5px' }} />
								<Input name="ytUrl" label="Youtube:" type="text" placeholder="Enter your Youtube URL" style={{marginTop: '5px' }} />

								<SubmitButton style={{marginTop: "10px"}} color="primary" disabled={isSubmitting || this.props.readOnly === true}>
									{submitBtn}
								</SubmitButton>
							</RGForm>
						}} />
	}
}

export default UserSettingsForm;



// WEBPACK FOOTER //
// ./src/views/user/UserSettingsForm.js